var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeviceDesktopMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.28571 3C2.13831 3 2 3.12387 2 3.3V12H18V3.3C18 3.12387 17.8617 3 17.7143 3H2.28571ZM0 3.3C0 2.04019 1.01296 1 2.28571 1H17.7143C18.987 1 20 2.04019 20 3.3V13.7C20 14.9598 18.987 16 17.7143 16H12.5L13.5 18H14C14.5523 18 15 18.4477 15 19C15 19.5523 14.5523 20 14 20H6C5.44772 20 5 19.5523 5 19C5 18.4477 5.44772 18 6 18H6.5L7.5 16H2.28571C1.01296 16 0 14.9598 0 13.7V3.3Z",
    fill: "#647FB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceDesktopMenu);
export default __webpack_public_path__ + "static/media/icon-device-desktop-menu.baeb7f2cd63f019ad578ee16858167fb.svg";
export { ForwardRef as ReactComponent };